import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { FileSpreadsheet, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { dashboardAPI } from '../../services/api';

const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

// Últimos 12 meses (mais recente primeiro) como "YYYY-MM"
const opcoes = () => {
  const hoje = new Date();
  return Array.from({ length: 12 }, (_, i) => {
    const d = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
    return {
      valor: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
      rotulo: `${MESES[d.getMonth()]}/${d.getFullYear()}`,
    };
  });
};

export const MonthlyReportExport = () => {
  const meses = opcoes();
  const [mes, setMes] = useState(meses[0].valor);
  const [baixando, setBaixando] = useState(false);

  const baixar = async () => {
    const [ano, m] = mes.split('-').map(Number);
    setBaixando(true);
    try {
      await dashboardAPI.exportMonthlyReport(ano, m);
      toast.success('Relatório gerado!');
    } catch {
      toast.error('Não foi possível gerar o relatório');
    } finally {
      setBaixando(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Select value={mes} onValueChange={setMes}>
        <SelectTrigger className="w-full sm:w-[160px]" data-testid="report-month-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {meses.map((o) => (
            <SelectItem key={o.valor} value={o.valor}>{o.rotulo}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button onClick={baixar} disabled={baixando} data-testid="export-monthly-report"
        className="bg-gradient-to-r from-emerald-600 to-teal-600 whitespace-nowrap">
        {baixando
          ? <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          : <FileSpreadsheet className="w-4 h-4 mr-2" />}
        Relatório do mês
      </Button>
    </div>
  );
};

export default MonthlyReportExport;
